import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import RoomTypeService from "../../services/roomType.service";


export const addroomType = createAsyncThunk(
  "roomType/addroomType",
  async (item, thunkAPI) => {
    try {
      const response = await RoomTypeService.addRoomType(item);
      return response.data; // Return actual data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getroomType = createAsyncThunk(
  "roomType/getroomType",
  async (item, thunkApi) => {
    try {
      const response = await RoomTypeService.getRoomType(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editroomType = createAsyncThunk(
  "roomType/editroomType",
  async (item, thunkAPI) => {
    try {
      const response = await RoomTypeService.editRoomType(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const addroom = createAsyncThunk(
  "room/addroom",
  async (item, thunkAPI) => {
    try {
      const response = await RoomTypeService.addRooms(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getroom = createAsyncThunk(
  "room/getroom",
  async (item, thunkApi) => {
    try {
      const response = await RoomTypeService.getRooms(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editroom = createAsyncThunk(
  "room/editroom",
  async (item, thunkAPI) => {
    try {
      const response = await RoomTypeService.editRooms(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const addavailability = createAsyncThunk(
  "room/addavailability",
  async (item, thunkAPI) => {
    try {
      const response = await RoomTypeService.addAvailability(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getavailability = createAsyncThunk(
  "room/getavailability",
  async (item, thunkApi) => {
    try {
      const response = await RoomTypeService.getAvailability(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const editavailability = createAsyncThunk(
  "room/editavailability",
  async (item, thunkAPI) => {
    try {
      const response = await RoomTypeService.editAvailability(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


const initialState = {
  loading: false,
  error: "",
  roomTypes: [],
  rooms: [],
  availability: [],
};

// **Slice**
const roomTypeSlice = createSlice({
  name: "roomType",
  initialState,
  extraReducers: (builder) => {
    builder
     
      .addCase(getroomType.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getroomType.fulfilled, (state, action) => {
        state.loading = false;
        state.roomTypes = action.payload;
      })
      .addCase(getroomType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

   
      .addCase(addroomType.pending, (state) => {
        state.loading = true;
      })
      .addCase(addroomType.fulfilled, (state, action) => {
        state.loading = false;
        state.roomTypes.push(action.payload);
      })
      .addCase(addroomType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

  
      .addCase(editroomType.pending, (state) => {
        state.loading = true;
      })
      .addCase(editroomType.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.roomTypes.findIndex((rt) => rt.id === action.payload.id);
        if (index !== -1) {
          state.roomTypes[index] = action.payload;
        }
      })
      .addCase(editroomType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

  
      .addCase(getroom.pending, (state) => {
        state.loading = true;
      })
      .addCase(getroom.fulfilled, (state, action) => {
        state.loading = false;
        state.rooms = action.payload;
      })
      .addCase(getroom.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

  
      .addCase(addroom.pending, (state) => {
        state.loading = true;
      })
      .addCase(addroom.fulfilled, (state, action) => {
        state.loading = false;
        state.rooms.push(action.payload);
      })
      .addCase(addroom.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getavailability.pending, (state) => {
        state.loading = true;
      })
      .addCase(getavailability.fulfilled, (state, action) => {
        state.loading = false;
        state.availability = action.payload;
      })
      .addCase(getavailability.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

    
      .addCase(addavailability.pending, (state) => {
        state.loading = true;
      })
      .addCase(addavailability.fulfilled, (state, action) => {
        state.loading = false;
        state.availability.push(action.payload);
      })
      .addCase(addavailability.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

  
      .addCase(editavailability.pending, (state) => {
        state.loading = true;
      })
      .addCase(editavailability.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.availability.findIndex((a) => a.id === action.payload.id);
        if (index !== -1) {
          state.availability[index] = action.payload;
        }
      })
      .addCase(editavailability.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});


export default roomTypeSlice.reducer;
